import { useState } from 'react';

export default function useAuto() {
  const [autoJointing, setAutoJointing] = useState(true);
  const [autoSpacing, setAutoSpacing] = useState(true);
  const [autoSplitSentence, setAutoSplitSentence] = useState(true);
  // WSD 는 베타라 기본은 끔 — 켜면 추론이 한 번 더 돌아 비용이 붙는다.
  const [withSense, setWithSense] = useState(false);
  // raw 는 후처리를 끄는 진단용 옵션이라 기본은 끔.
  const [raw, setRaw] = useState(false);

  return {
    autoJointing,
    autoSpacing,
    autoSplitSentence,
    withSense,
    raw,
    setAutoJointing,
    setAutoSpacing,
    setAutoSplitSentence,
    setWithSense,
    setRaw
  };
}
